<template>
  <div>
    <x-table url="/pc/asset/operate" ref="xTable" :params="{ id }" max-height='500'>
      <el-table-column
        :label="item.label"
        :prop="item.model"
        show-overflow-tooltip
        v-for="item in columnArr"
        :key="item.model"
        ><template slot-scope="scope">
          <el-tag v-if="item.model == 'orderType'">{{
            orderTypeFulter(scope.row[item.model])
          }}</el-tag>
          <span v-else>{{ scope.row[item.model] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="详情">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.orderType !== 'in'"
            type="text"
            class="addColor"
            @click="details(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </x-table>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
  },
  data() {
    return {
      optionsArr: [
        {
          label: "手动录入",
          model: "in",
        },
        {
          label: "领用",
          model: "receive",
        },
        {
          label: "退还",
          model: "refund",
        },

        {
          label: "借用",
          model: "borrow",
        },
        {
          label: "归还",
          model: "giveback",
        },
        {
          label: "变更",
          model: "change",
        },
        {
          label: "调拨",
          model: "allot",
        },
        {
          label: "维修中",
          model: "repair",
        },
        {
          label: "维修完成",
          model: "erepair",
        },
        {
          label: "处置",
          model: "dispose",
        },
      ],
      columnArr: [
        {
          label: "单号",
          model: "orderNo",
        },
        {
          label: "资产类型",
          model: "orderType",
        },
        {
          label: "操作时间",
          model: "createTime",
        },
        {
          label: "操作用户",
          model: "createName",
        },
        {
          label: "操作內容",
          model: "operateRemark",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    details(row) {
      /*   {
          label: "领用",
          model: "receive",
        },
        {
          label: "退还",
          model: "refund",
        },

        {
          label: "借用",
          model: "borrow",
        },
        {
          label: "归还",
          model: "giveback",
        },
        {
          label: "变更",
          model: "change",
        },
        {
          label: "调拨",
          model: "allot",
        },
        {
          label: "维修",
          model: "repair",
        },
        {
          label: "处置",
          model: "dispose",
        }, */

      switch (row.orderType) {
        case "change":
          this.$createDialog(this, {
            dialogConfig: { title: "资产变更的详情", width: "860px" },
            namespace: "asset_change_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData:[row.asset],

              defaultRow: row.inJson,
            },
          });

          break;

        case "receive":
          this.$createDialog(this, {
            dialogConfig: { title: "资产领用的详情", width: "860px" },
            namespace: "asset_receive_receiveEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });

          break;

        case "refund":
          this.$createDialog(this, {
            dialogConfig: { title: "资产退还详情", width: "860px" },
            namespace: "asset_receive_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });

          break;

        case "borrow":
          this.$createDialog(this, {
            dialogConfig: { title: "资产借用详情", width: "860px" },
            namespace: "asset_borrow_borrowEdit",
            whetherDestruction: true,

            assemblyConfig: {
               id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });

          break;

        case "giveback":
          this.$createDialog(this, {
            dialogConfig: { title: "资产归还详情", width: "860px" },
            namespace: "asset_borrow_returnEdit",
            whetherDestruction: true,

            assemblyConfig: {
             id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });
          break;
        case "allot":
          this.$createDialog(this, {
            dialogConfig: { title: "资产调拨详情", width: "860px" },
            namespace: "asset_allot_edit",
            whetherDestruction: true,

            assemblyConfig: {
               id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });
          break;

        case "repair":
          this.$createDialog(this, {
            dialogConfig: { title: "资产维修详情", width: "860px" },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
             id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });
          break;

case "erepair":
          this.$createDialog(this, {
            dialogConfig: { title: "资产维修详情", width: "860px" },
            namespace: "asset_maintain_edit",
            whetherDestruction: true,

            assemblyConfig: {
             id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });
          break;
        case "dispose":
          this.$createDialog(this, {
            dialogConfig: { title: "资产处置详情", width: "860px" },
            namespace: "asset_dispose_edit",
            whetherDestruction: true,

            assemblyConfig: {
              id: row.id,
              ids: row.inJson.ids,
              changeData: [row.asset],
              defaultRow: row.inJson,
            },
          });
          break;
      }
    },
    orderTypeFulter(model) {
      let str = "";
      for (let i = 0; i < this.optionsArr.length; i++) {
        if (this.optionsArr[i].model == model) {
          str = this.optionsArr[i].label;
          break;
        }
      }
      return str;
    },
  },
};
</script>
<style scoped></style>
